/* AP 6.0 — panier (tiroir + page /cart), en complément de assets/cart.js de Dawn.
   1) Changement de format sur une ligne (<select data-ap-line-size>) : ajoute la nouvelle variante en recopiant les propriétés
      de la ligne (cadre Globo recalculé au nouveau format : clé frame-<taille>, variante et prix du cadre via AP.globoProps),
      puis retire l'ancienne ligne, et re-rend tiroir / page / pastille. Le cadre ne se change pas dans le panier.
   2) Dates de réception estimées ([data-ap-eta="<jours>"]), dans la langue de la page. */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var GPO = /^(_has_gpo|_gpo_|frame-)/;

  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok || d.status) throw new Error(d.description || d.message || 'cart');
        return d;
      });
    });
  }

  function sectionsWanted() {
    var s = [];
    if (document.querySelector('cart-drawer')) s.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) s.push('cart-icon-bubble');
    var items = document.getElementById('main-cart-items'), foot = document.getElementById('main-cart-footer');
    if (items && items.dataset.id) s.push(items.dataset.id);
    if (foot && foot.dataset.id) s.push(foot.dataset.id);
    return s;
  }

  function inner(html, sel) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
    return el ? el.innerHTML : null;
  }

  function render(state) {
    var S = state.sections || {}, empty = state.item_count === 0, h;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && S['cart-drawer']) {
      var di = drawer.querySelector('.drawer__inner');
      if ((h = inner(S['cart-drawer'], '.drawer__inner')) !== null && di) di.innerHTML = h;
      drawer.classList.toggle('is-empty', empty);
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && S['cart-icon-bubble'] && (h = inner(S['cart-icon-bubble'], '.shopify-section')) !== null) bubble.innerHTML = h;
    var items = document.getElementById('main-cart-items'), foot = document.getElementById('main-cart-footer');
    if (items && S[items.dataset.id] && (h = inner(S[items.dataset.id], '.js-contents')) !== null) {
      items.querySelector('.js-contents').innerHTML = h;
      var ci = items.closest('cart-items'); if (ci) ci.classList.toggle('is-empty', empty);
    }
    if (foot && S[foot.dataset.id] && (h = inner(S[foot.dataset.id], '.js-contents')) !== null) {
      var fj = foot.querySelector('.js-contents'); if (fj) fj.innerHTML = h;
      foot.classList.toggle('is-empty', empty);
      var co = document.getElementById('checkout'); if (co) co.disabled = empty;
    }
    var dco = document.getElementById('CartDrawer-Checkout'); if (dco) dco.disabled = empty;
    document.dispatchEvent(new CustomEvent('ap:cart', { detail: state }));
  }

  function sameProps(a, b) { return JSON.stringify(a || {}) === JSON.stringify(b || {}); }

  function changeSize(sel) {
    var line = sel.closest('[data-ap-line]');
    if (!line || !window.AP || line.classList.contains('is-busy')) return;
    var key = line.dataset.key, newId = +sel.value;
    var was = sel.querySelector('option[selected]'), oldId = was ? +was.value : 0;
    var opt = sel.options[sel.selectedIndex], size = AP.sizeKey(opt ? opt.text : '');
    var err = line.querySelector('.cart-item__error-text');
    var spin = line.querySelector('.loading__spinner');
    var item;
    line.classList.add('is-busy'); sel.disabled = true;
    if (spin) spin.classList.remove('hidden');
    if (err) err.textContent = '';

    getCart()
      .then(function (cart) {
        item = cart.items.filter(function (i) { return i.key === key; })[0] ||
          cart.items.filter(function (i, n) { return i.variant_id === oldId && n === (+line.dataset.index - 1); })[0];
        if (!item) throw new Error('line');
        if (item.variant_id === newId) return null;
        var props = {}, frame = '';
        Object.keys(item.properties || {}).forEach(function (k) {
          var v = item.properties[k];
          if (/^frame-/.test(k)) frame = v;
          if (!GPO.test(k) && v !== null && v !== '') props[k] = v;
        });
        var fid = AP.cadreId(frame);
        if (fid) {
          var g = AP.globoProps(size, fid, 0);
          if (!g) throw new Error('frame');
          Object.keys(g).forEach(function (k) { props[k] = g[k]; });
        }
        var add = { id: newId, quantity: item.quantity };
        if (Object.keys(props).length) add.properties = props;
        /* les clés de ligne changent quand les remises sont recalculées (ajout) : on retrouve l'ancienne ligne
           après l'ajout par variante + propriétés identiques, puis on la retire par sa nouvelle clé. */
        return post('cart/add.js', { items: [add] }).then(getCart).then(function (cart2) {
          var old = cart2.items.filter(function (i) { return i.variant_id === item.variant_id && sameProps(i.properties, item.properties); })[0];
          if (!old) return refresh(sectionsWanted());
          return post('cart/change.js', { id: old.key, quantity: 0, sections: sectionsWanted(), sections_url: window.location.pathname });
        });
      })
      .then(function (state) {
        if (state && state.sections) { render(state); announce(); }
        else if (!state) { line.classList.remove('is-busy'); sel.disabled = false; if (spin) spin.classList.add('hidden'); }
      })
      .catch(function () {
        line.classList.remove('is-busy'); sel.disabled = false;
        if (spin) spin.classList.add('hidden');
        if (was) sel.value = was.value;
        if (err) err.textContent = sel.dataset.error || '';
        refresh(sectionsWanted());
      });
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* re-rend des sections du panier à partir de l'état serveur (tiroir et/ou page) */
  function refresh(ids) {
    ids = ids.filter(Boolean);
    if (!ids.length) return Promise.resolve(null);
    return Promise.all([
      getCart(),
      /* pas d'en-tête Accept JSON : sinon /cart renvoie le panier au lieu des sections */
      fetch(root + 'cart?sections=' + ids.join(',')).then(function (r) { return r.json(); })
    ]).then(function (res) { res[0].sections = res[1]; render(res[0]); return res[0]; }).catch(function () { return null; });
  }

  function announce() {
    var live = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (live) { live.setAttribute('aria-hidden', 'false'); setTimeout(function () { live.setAttribute('aria-hidden', 'true'); }, 1000); }
  }

  function pageIds() {
    var items = document.getElementById('main-cart-items'), foot = document.getElementById('main-cart-footer');
    return items ? [items.dataset.id, foot && foot.dataset.id, 'cart-icon-bubble'] : [];
  }

  /* Synchronise tiroir et page /cart (Dawn ne re-rend que la vue modifiée) :
     - quantité/suppression dans la page → tiroir ; dans le tiroir (ouvert sur /cart) → page ;
     - ajout (fiche, composeur, AP.addItems) pendant qu'on est sur /cart → page (lignes + récapitulatif). */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      var page = document.getElementById('main-cart-items'), drawer = document.querySelector('cart-drawer');
      var fromDrawer = ev && ev.cartData && ev.cartData.sections && ev.cartData.sections['cart-drawer'] !== undefined;
      if (ev && ev.source === 'cart-items') {
        if (page && fromDrawer) refresh(pageIds());
        else if (drawer && !fromDrawer) refresh(['cart-drawer']).then(function (c) {
          if (c && c.item_count === 0 && page) { var a = page.querySelector('.ap-cempty__ctas a'); if (a) a.focus(); }
        });
      } else if (page) refresh(pageIds());
    });
  }

  /* Dawn (cart.js) appelle trapFocus sur le tiroir même fermé (modif. sur /cart) et avec un conteneur absent
     quand le panier devient vide → erreur JS + focus piégé dans un tiroir invisible. */
  if (typeof window.trapFocus === 'function' && !window.trapFocus.apSafe) {
    var tf = window.trapFocus;
    window.trapFocus = function (c, el) {
      if (!c) return;
      var d = document.querySelector('cart-drawer');
      if (d && d.contains(c) && !d.classList.contains('active')) {
        if (el && !d.contains(el) && el.focus) el.focus();
        return;
      }
      return tf.apply(this, arguments);
    };
    window.trapFocus.apSafe = true;
  }

  /* bouton Commander : pas de double envoi (double tap mobile) */
  document.addEventListener('submit', function (e) {
    var b = e.submitter;
    if (!b || b.name !== 'checkout') return;
    if (b.getAttribute('aria-busy') === 'true') { e.preventDefault(); return; }
    b.setAttribute('aria-busy', 'true'); b.classList.add('is-sending');
    setTimeout(function () { b.removeAttribute('aria-busy'); b.classList.remove('is-sending'); }, 8000);
  }, true);
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) document.querySelectorAll('[name=checkout][aria-busy]').forEach(function (b) { b.removeAttribute('aria-busy'); b.classList.remove('is-sending'); });
    /* retour/avance navigateur : la page vient du bfcache ou du cache HTTP, donc d'AVANT le dernier ajout
       (pastille vide, tiroir « Votre panier est vide » alors que le panier est plein) → re-rendu depuis le serveur */
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (e.persisted || (nav && nav.type === 'back_forward')) refresh(sectionsWanted());
  });

  /* capture : empêche l'écouteur « change » de <cart-items> (quantité) de traiter le select de format */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('select[data-ap-line-size]')) {
      e.stopPropagation();
      changeSize(t);
    }
  }, true);

  /* dates de réception estimées */
  var lang = document.documentElement.lang || 'fr';
  var fmt;
  try { fmt = new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'long' }); } catch (e) { fmt = null; }
  function eta(days) {
    /* jours OUVRÉS (comme la fiche produit, ap-pdp.js) : sinon le panier annonce 2 jours plus tôt que la fiche */
    var d = new Date(), n = days;
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return fmt ? fmt.format(d) : d.toLocaleDateString();
  }
  function fillEta() {
    document.querySelectorAll('[data-ap-eta]:empty').forEach(function (el) { el.textContent = eta(+el.dataset.apEta || 5); });
  }
  fillEta();
  var pending = false;
  new MutationObserver(function () {
    if (pending) return; pending = true;
    requestAnimationFrame(function () { pending = false; fillEta(); });
  }).observe(document.body, { childList: true, subtree: true });

  window.AP = window.AP || {};
  AP.cartRender = render;
})();
